import { usePhase2ReportStore } from '@/entities/phase2-report/model/report.store';
import { useToastStore } from '@/shared/lib/store';
import { ReportTab } from '@/shared/types/report-phase2/constant';
import { Icon } from '@/shared/ui';
import { useRouter } from '@tanstack/react-router';
import { FC, ReactNode } from 'react';

interface GoToReportProps {
    ct: 'weclass' | 'student';
    gubun: 't' | 's';
    publishType: number; // 발행 구분 1: class, 2: url
    trgtId: number;
    textbkId: number;
    publishTab?: string;
    stntId?: string;
    // setsId?: string;
    nickname?: string;
    styles: {
        button?: string;
    };
    icon?: boolean;
    claId?: string;
    submAt?: FlagYn;
}

export const GoToPhase2Report: FC<GoToReportProps> = ({
    ct,
    gubun,
    publishType,
    trgtId,
    textbkId,
    stntId,
    nickname,
    styles,
    icon,
    submAt,
    claId,
    // claId,
}) => {
    const { showToast } = useToastStore();
    const { setGoToPhase2Report, setClaId } = usePhase2ReportStore();
    const router = useRouter();

    const showToastMessage = (message: ReactNode, type: ToastType) => {
        showToast(message, 2000, type);
    };

    const goToPhase2ReportHandler = () => {
        if (submAt === 'N') {
            showToastMessage(
                <p className="txt-s">미제출한 경우, 평가 결과 및 리포트를 확인할 수 없습니다.</p>,
                'error'
            );
            return;
        }
        if (claId && publishType === 1) {
            setClaId(claId);
        } else {
            setClaId(null);
        }
        if (ct === 'weclass') {
            setGoToPhase2Report(null, null, textbkId, publishType);
            router.navigate({
                to: '/report/eval/$gubun',
                params: { gubun },
                search: {
                    ct: 'weclass',
                    evalid: trgtId,
                    rtab: ReportTab.Answer,
                    type: publishType === 1 ? 'class' : 'url',
                },
            });
        } else if (ct === 'student') {
            setGoToPhase2Report(stntId ?? null, nickname ?? null, textbkId, publishType);
            router.navigate({
                to: '/report/eval/$gubun',
                params: { gubun },
                search: {
                    ct: 'student',
                    evalid: trgtId,
                    rtab: ReportTab.Answer,
                    type: publishType === 1 ? 'class' : 'url',
                },
            });
        }
    };

    return (
        <button
            type="button"
            className={styles.button}
            // title={item.subject}
            onClick={goToPhase2ReportHandler}
        >
            {icon && <Icon icon="report" />} 리포트 보기
        </button>
    );
};
